/**
 * Bytbil Accesspaket — lagerflödet från fordonsdisken.
 *
 * Samma inbäddning som gamla sajten: hämta Bytbils asset-manifest och lägg in
 * varje entrypoint i <head>. React-programmet monterar sig sedan självt i
 * #tfap-root. Koden låg i gamla temats header.php och är flyttad hit oförändrad
 * i sak.
 *
 * TVÅ SKILLNADER mot gamla sajten, båda avsiktliga:
 *
 *   1. Filen laddas BARA på sidor som har monteringspunkten. Gamla sajten
 *      körde den i header.php, alltså på varenda sidvisning — verkstadssidor,
 *      kontaktsidan och kassan hämtade en React-bundle de aldrig använde.
 *   2. Manifestet kan utebli. Gamla laddaren tystnade då (`if status !== 200
 *      return false`) och lämnade en tom yta utan förklaring. Här skrivs ett
 *      meddelande i rutan i stället, så att ett avbrott hos Bytbil ser ut som
 *      ett avbrott och inte som att lagret är slut.
 */
( function () {
	var bas = 'https://bergmansmotor.accesspaket.bytbilcms.com/';
	var rest = bas + 'wp-json/accesspackage/v1';
	var bygge = bas + 'app/mu-plugins/triggerfish-bytbil-accesspaket/frontend/build/';

	// GLOBALA, med gamla sajtens namn. Gamla temat deklarerade dem med `var` i
	// ett inline-skript i <head>, alltså på window, och Bytbils app läser dem
	// därifrån för att veta var API:et ligger. Inlindade i en IIFE laddade
	// appen sin bundle, ritade sitt skelett och stannade på "Laddar..." utan
	// ett enda anrop till /cars och utan ett konsolfel.
	window.baseUrl = bas;
	window.restUrl = rest;
	window.buildUrl = bygge;

	function rot() { return document.getElementById( 'tfap-root' ); }

	function misslyckades() {
		var r = rot();
		if ( ! r || r.children.length ) { return; }
		var p = document.createElement( 'p' );
		p.className = 'bm-lager__avbrott';
		p.textContent = 'Lagerlistan går inte att visa just nu. Ring 033 23 00 10 så berättar vi vad som står inne.';
		r.appendChild( p );
	}

	function ladda() {
		if ( ! rot() ) { return; }
		var xhr = new XMLHttpRequest();
		xhr.open( 'GET', bygge + 'asset-manifest.json?siteUrl=' + rest, true );
		xhr.onload = function () {
			if ( 200 !== xhr.status ) { misslyckades(); return; }
			var json;
			try { json = JSON.parse( xhr.response ); } catch ( e ) { misslyckades(); return; }
			var filer = ( json && json.entrypoints ) || [];
			if ( ! filer.length ) { misslyckades(); return; }
			filer.forEach( function ( fil ) {
				if ( ! fil ) { return; }
				var tagg;
				if ( -1 !== fil.indexOf( '.css' ) ) {
					tagg = document.createElement( 'link' );
					tagg.rel = 'stylesheet';
					tagg.href = bygge + fil;
				} else {
					tagg = document.createElement( 'script' );
					tagg.src = bygge + fil;
				}
				document.head.appendChild( tagg );
			} );
		};
		xhr.onerror = misslyckades;
		xhr.send();
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', ladda );
	} else { ladda(); }
}() );
